import React from 'react';
import Upload from '../../components/UserDashboard/Upload';

const UploadPage = () => {
  return <Upload />;
};

export default UploadPage;
